const Q = require('Q');
const CATEGORIES = require('../enums/review-category-enum');
function ReviewsByProduct(ReviewService, currentProduct, $state, $stateParams) {
	this.ReviewService = ReviewService;
	this.currentProduct = currentProduct;
	this.$state = $state;
	this.$stateParams = $stateParams;
}

ReviewsByProduct.prototype.get = function (request, options, bazaarvoiceCallEnabled) {
	const deferred = Q.defer();

	const model = {};
	model.returnHref = this.$state.href(CATEGORIES.PRODUCT.URL, this.$stateParams);
	model.category = CATEGORIES.PRODUCT.DISPLAY;

	model.currentProduct = this.currentProduct;
	model.viewMoreHref = this.$state.href(`${CATEGORIES.PRODUCT.URL}.reviews`, this.$stateParams);
	if (bazaarvoiceCallEnabled) {
		this.ReviewService.getBVReviewsByProductId(request, options).then((productReview) => {
			model.overall = productReview.overall;
			model.reviews = productReview.reviews;
			deferred.resolve(model);
		});
	} else {
		this.ReviewService.getByProductId(request, options).then((productReview) => {
			model.overall = productReview.overall;
			model.reviews = productReview.reviews;
			deferred.resolve(model);
		});
	}
	return deferred.promise;
};

module.exports = ReviewsByProduct;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/customer-reviews/factory/reviews-by-product.js
 **/